import { getInitialState as getSearchResultsInitialState } from "../searchResults/state.js";
export const getInitialState = () => ({
    outbound: getSearchResultsInitialState(),
    inbound: getSearchResultsInitialState()
});
